/*************************************************************************
 *
 * KLEAREXPRESS CONFIDENTIAL
 * __________________
 *
 *  Copyright (c) 2018 - 2018 KlearExpress Corporation.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of KlearExpress Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KlearExpress Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KlearExpress Corporation.
 */

// const API_URL= process.env.NODE_ENV === 'production' ? process.env.REACT_APP_PROD_API_URL : process.env.REACT_APP_DEV_API_URL;
const API_URL = window._env_.REACT_APP_API_URL;

export default {
  //login

  login: function(email, password) {
    return fetch(API_URL, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      method: "post",
      body: JSON.stringify({
        eventMessage: {
          email: email,
          hashedPassword: password,
          typeOfUser: "FREIGHT_FORWARDER"
        },
        eventType: "KXUSER_LOGIN",
        eventTime: Date.now()
      })
    });
  },

  specificUser: function(customerCode, kxToken) {
    return fetch(API_URL, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        kxToken
      },
      method: "post",
      body: JSON.stringify({
        eventMessage: {
          customerCode,
        },
        eventType: "ASSUME_USER",
        eventTime: Date.now()
      })
    });
  },

  customerList: function(requestParams, kxToken) {
    return fetch(API_URL, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        kxToken
      },
      method: "post",
      body: JSON.stringify({
        eventMessage: requestParams,
        eventType: "LIST_OF_CUSTOMERS",
        eventTime: Date.now()
      })
    });
  },


  authenticateGeneratedOTP: (payload) => {
    return fetch(API_URL, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      method: "post",
      body: JSON.stringify({
        eventMessage: payload,
        eventType: "VALIDATE_AUTH_TOKEN",
        eventTime: Date.now()
      })
    })
  },

  sendKnEmail: (email, knEmail, portal, hashedPassword) => {
    return fetch(API_URL, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "post",
      body: JSON.stringify({
        eventMessage: {
          email, knEmail, portal, hashedPassword
        },
        eventType: "SET_AUTH_TOKEN",
        eventTime: Date.now()
      })
    })
  },

  inquiry: function(fullName, companyName, email, jobTitle, shipmentNumber, phoneNumber) {
    return fetch(API_URL, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      method: "post",
      body: JSON.stringify({
        eventMessage: {
          userBasicInfo: {
            fullName: fullName,
            companyName: companyName,
            email: email,
            typeOfUser: "PROSPECT_USER",
            role: "USER_ADMIN",
            jobTitle: jobTitle
          },
          userInfo: {
            shippingInformation: {
              numberOfShipmentImported: shipmentNumber
            }
          },
          phone: {
            typeOfPhone: 3,
            isdCode: "1",
            phoneNo: phoneNumber
          }
        },
        eventType: "CREATE_KXUSER",
        eventTime: Date.now()
      })
    });
  },

  createCustomer: function(companyName, email, typeOfUser, contactName) {
    return fetch(API_URL, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      method: "post",
      body: JSON.stringify({
        eventMessage: {
          userBasicInfo: {
            role: "USER_ADMIN",
            companyName: companyName,
            email: email,
            typeOfUser: typeOfUser,
            contactName: contactName
          }
        },
        eventType: "CREATE_KXUSER",
        eventTime: Date.now()
      })
    });
  },

  authenticateToken: (tempToken) => {
    return fetch(API_URL, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        kxToken: tempToken
      },
      method: "post",
      body: JSON.stringify({
        eventMessage: {
          kxToken: tempToken
        },

        eventType: "SIGNUP_KXTOKEN_VALIDATION",
        eventTime: Date.now()
      })
    });
  },

  termsOfService: function(tempToken) {
    return fetch(API_URL, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        kxToken: tempToken
      },
      method: "post",
      body: JSON.stringify({
        eventMessage: {
          date: {
            epochs: Date.now()
          }
        },

        eventType: "GET_KXUSER_SIGNUP_DETAILS",
        eventTime: Date.now()
      })
    });
  },

  resendVerificationLink: (kxToken) => {
    return fetch(API_URL, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        // kxToken
      },
      method: "post",
      body: JSON.stringify({
        eventMessage: {
          kxToken
        },

        eventType: "RESEND_VERIFY_EMAIL",
        eventTime: Date.now()
      })
    });
  },

  //basic-info.js

  updateProfile: function(tempToken, companyName, email, contactName, password, phone) {
    return fetch(API_URL, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        kxToken: tempToken
      },
      method: "post",
      body: JSON.stringify({
        eventMessage: {
          userBasicInfo: {
            companyName: companyName,
            email: email,
            contactName: contactName,
            hashedPassword: password,
            additionalEmail: "",
            typeOfUser: "FREIGHT_FORWARDER",
            displayImage: ""
          },
          phone: [
            {
              typeOfPhone: "WORK",
              isdCode: "1",
              phoneNo: phone
            }
          ]
        },
        eventType: "KXUSER_UPDATE_PERSONAL_PROFILE",
        eventTime: Date.now()
      })
    });
  },

  //basic-info-company.js

  companyInfo: function(kxCustomerToken, businessName, businessAddress1, businessAddress2, city, state, country, businessType, businessIncorporation, type, importerNumber) {
    return fetch(API_URL, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        kxToken: kxCustomerToken
      },
      method: "post",
      body: JSON.stringify({
        eventMessage: {
          userInfo: {
            companyInformation: {
              businessName: businessName,
              businessAddress: {
                address1: businessAddress1,
                address2: businessAddress2,
                city: city,
                state: state,
                country: country
              },
              businessType: businessType,
              businessIncorporation: businessIncorporation,
              importerNumber: {
                type: type,
                number: importerNumber
              }
            }
          }
        },
        eventType: "KXUSER_UPDATE_COMPANY_INFO",
        eventTime: Date.now()
      })
    });
  },

  busSize: function(kxCustomerToken, number, frequency) {
    return fetch(API_URL, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        kxToken: kxCustomerToken
      },
      method: "post",
      body: JSON.stringify({
        eventMessage: {
          userInfo: {
            businessSize: {
              shipments: number,
              shipmentFrequency: frequency
            }
          }
        },
        eventType: "KXUSER_UPDATE_BUSINESS_SIZE",
        eventTime: Date.now()
      })
    });
  },

  shippingInfo: function(kxCustomerToken, incoterms, freightForwarders, carriers, brokerData) {
    return fetch(API_URL, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        kxToken: kxCustomerToken
      },
      method: "post",
      body: JSON.stringify({
        eventMessage: {
          userInfo: {
            shippingInformation: {
              incoterms: incoterms,
              freightForwarders: freightForwarders,
              carriers: carriers,
              customerBrokers: brokerData
            }
          }
        },
        eventType: "KXUSER_UPDATE_SHIPPING_INFO",
        eventTime: Date.now()
      })
    });
  },

  poa: function() {
    return fetch(API_URL, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      method: "post",
      body: JSON.stringify({
        eventMessage: {
          user: {
            email: "test7@klearexpress.com"
          },

          userInfo: {
            poa: {
              BII: "Delveras, USA",
              DBA: "Delveras, USA",
              businessAddress: {
                streetAddress: "ljkdlc",
                city: "San Jose",
                state: "California",
                zipcode: "12345",
                country: "USA"
              },
              ports: [],
              eSignature: "...",
              title: "..",
              timestamp: "..."
            }
          }
        },
        eventType: "KXUSER_UPDATE_POA",
        eventTime: Date.now()
      })
    });
  },

  bondInfo: function(kxCustomerToken, number, amount, ownership, type) {
    return fetch(API_URL, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        kxToken: kxCustomerToken
      },
      method: "post",
      body: JSON.stringify({
        eventMessage: {
          userInfo: {
            bondInfo: {
              bondNumber: number,
              bondAmount: amount,
              bondOwnership: ownership,
              bondType: type
            }
          }
        },
        eventType: "KXUSER_UPDATE_BOND_INFO",
        eventTime: Date.now()
      })
    });
  },

  notifications: function(kxCustomerToken, language, emailNotify, textNotify, shipmentNotify, docChangeNotify, customsNotify, logisticsNotify, brokerNotify) {
    return fetch(API_URL, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        kxToken: kxCustomerToken
      },
      method: "post",
      body: JSON.stringify({
        eventMessage: {
          userInfo: {
            preferences: {
              preferredLanguage: language,
              emailCommunication: emailNotify,
              textCommunication: textNotify,
              shipmentNotification: shipmentNotify,
              docChangeNotification: docChangeNotify,
              customsResponseNotification: customsNotify,
              logisticsTrackingNotification: logisticsNotify,
              brokerNotification: brokerNotify
            }
          }
        },
        eventType: "KXUSER_UPDATE_PREFERENCES",
        eventTime: Date.now()
      })
    });
  },

  getCustomerInfo: function(kxCustomerToken) {
    return fetch(API_URL, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        kxToken: kxCustomerToken
      },
      method: "post",
      body: JSON.stringify({
        eventType: "GET_KXUSER",
        eventMessage: {},
        eventTime: Date.now()
      })
    });
  },

  addACHPayment: function(email, type, fullName, bankName, accountNumber, bankCity, state, country) {
    return fetch(API_URL, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      method: "post",
      body: JSON.stringify({
        eventMessage: {
          user: {
            email: "tamhong.sd@gmail.com"
          },

          bankDetails: [
            {
              type: type,
              fullName: fullName,
              bankName: bankName,
              accountNumber: accountNumber,
              bankCity: bankCity,
              state: state,
              country: country
            }
          ]
        },
        eventType: "KXUSER_UPDATE_BANK_DETAILS",
        eventTime: Date.now()
      })
    });
  },

  addCCPayment: function(email, type, fullName, cardNumber, cvv, expMonth, expYear) {
    return fetch(API_URL, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      method: "post",
      body: JSON.stringify({
        eventMessage: {
          user: {
            email: email
          },
          creditCardDetails: [
            {
              type: type,
              fullName: fullName,
              cardNumber: cardNumber,
              cvv: cvv,
              expMonth: expMonth,
              expYear: expYear
            }
          ]
        },
        eventType: "KXUSER_UPDATE_BANK_DETAILS",
        eventTime: Date.now()
      })
    });
  },

  addTeam: function(kxCustomerToken, data) {
    return fetch(API_URL, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        kxToken: kxCustomerToken
      },
      method: "post",
      body: JSON.stringify({
        eventMessage: {
          customerInfo: {
            teamMember: [data]
          }
        },
        eventType: "KXUSER_UPDATE_ADD_TEAM_MEMBER",
        eventTime: Date.now()
      })
    });
  },

  forgotPassword: function(email) {
    return fetch(API_URL, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      method: "post",
      body: JSON.stringify({
        eventMessage: {
          email: email,
          typeOfUser: "CUSTOMER_USER"
        },
        eventType: "RESET_PASSWORD",
        eventTime: Date.now()
      })
    });
  },

  emailVerification: function(email) {
    return fetch(API_URL, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      method: "post",
      body: JSON.stringify({
        eventMessage: {
          email: email,
        },
        eventType: "COMPLETE_REGISTRATION_LINK",
        eventTime: Date.now()
      })
    });
  },

  resetPassword: function(kxCustomerToken, password) {
    return fetch(API_URL, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        kxToken: kxCustomerToken
      },
      method: "post",
      body: JSON.stringify({
        eventMessage: {
          userBasicInfo: {
            typeOfUser: "CUSTOMER_USER",
            hashedPassword: password
          }
        },
        eventType: "UPDATE_PASSWORD",
        eventTime: Date.now()
      })
    });
  }
};
